






























import Vue from 'vue';
import { unsplashSearch, unsplashDownload } from '@/firebaseConfig';


export interface UnsplashSearchInterface extends Vue {
  search(searchTerm: string): void;
  download(imageItem): void;
}

const MAX_PAGES = 4;

export default Vue.component('UnsplashSearch', {
  name: 'UnsplashSearch',
  props: {
    searchTerm: String,
    selectImageCallback: Function,
  },
  data() {
    return {
      page: 1,
      resultTerm: '',
      payload: {
        'total_pages': 0,
        results: [],
      },
      infiniteLoadState: {
        reset: () => {
          return;
        },
      },
    };
  },
  computed: {},
  methods: {
    //Select the image from the list
    selectImage(item) {
      this.selectImageCallback(item);
    },
    //Commit to using the image - equivalent of a download by Unsplash API guidelines
    download(imageItem) {
      console.log('Trigger download on:', imageItem?.id);
      //Trigger download endpoint on Unsplash
      unsplashDownload({ id: imageItem.id })
        .then((response) => {
          console.log(response.data);
        }).catch((reason) => {
          console.log(reason);
        },
      );
    },
    search(searchTerm: string) {
      console.log('Search', searchTerm);

      if (searchTerm && searchTerm != this.resultTerm) {

        unsplashSearch({ searchTerm: searchTerm, page: 1 })
          .then((response) => {
            //Reset page count on successful search
            this.page = 1;
            //Reset result search term on successful search
            this.resultTerm = searchTerm;

            //Replace whole payload on successful search
            this.payload = response.data;
            this.resetScroll();
          }).catch(reason => {
            console.log('Error loading Unsplash images', reason);
        });
      }
    },
    infiniteScrollHandler($state) {

      if (this.page >= MAX_PAGES || this.page >= this.payload?.total_pages) {
        $state.complete();
        console.log('No more pages to load');
        return;
      }

      this.page++;

      unsplashSearch({ searchTerm: this.resultTerm, page: this.page })
        .then((response) => {
          console.log('Unsplash results', response.data.results);
          this.payload.results = this.payload.results.concat(response.data.results);
          console.log('Loaded');
          setTimeout(function () {
            $state.loaded();
          }, 1000);
        }).catch((reason) => {
        console.log('Error loading Unsplash images', reason);
        $state.error();
      });

      //Store a reference to the infiniteLoader state object so that I can reset it on a new search
      this.infiniteLoadState = $state;
    },
    resetScroll() {
      //Go back to top
      window.scrollTo(0, 0);

      //Reset the infinite loader widget
      if (this.infiniteLoadState.reset) {
        this.infiniteLoadState.reset();
      }
    },
  },
})
;
